import React from 'react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="bg-dark-bg text-white pt-16 pb-20 px-4 md:px-8 border-b border-dark-surface" data-id="element-67">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-12" data-id="element-68">
        <div className="flex-1 text-center lg:text-left" data-id="element-69">
          <h1 className="font-oswald text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-4 uppercase tracking-tight" data-id="element-70">
            Hiciste todo bien. Cortaste el pan, saliste a correr, tomaste agua.
            Y la panza sigue ahí.
          </h1>
          <p className="font-inter text-xl md:text-2xl text-brand-orange mb-6 italic" data-id="element-71">
            Esto no es un problema de voluntad. Es un problema de orden.
          </p>
          <h2 className="font-inter text-lg md:text-xl text-gray-300 mb-10 leading-relaxed max-w-3xl mx-auto lg:mx-0" data-id="element-72">
            El Protocolo de 14 días que le enseña a tu cuerpo a usar su propia
            grasa abdominal como combustible. Sin cardio. Sin pasar hambre. Sin
            dejar el asado del domingo.
          </h2>
          <CTAButton data-id="element-73">👉 SÍ, QUIERO EMPEZAR HOY — $6.39</CTAButton>
          <p className="font-inter text-sm text-gray-500 mt-4" data-id="element-74">
            Acceso inmediato · PDF en tu email · Garantía de 7 días
          </p>
        </div>
        <div className="flex-1 w-full max-w-lg lg:max-w-none relative" data-id="element-75">
          <div className="absolute inset-0 bg-brand-orange/20 blur-[100px] rounded-full pointer-events-none" data-id="element-76"></div>
          <img src="https://cdn.magicpatterns.com/uploads/gtH1AeayVPdnYugjcA5RXV/Mockuo_Cero_Panza_14.png" alt="Cero Panza 14 Program Mockup" className="w-full h-auto relative z-10 drop-shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-77" />
        </div>
      </div>
    </section>;
}